import React, {Component} from 'react';
import {connect} from 'react-redux';

import store from 'store2';
import ModalsBootstrap from '../../ui-elements/modals-bootstrap';
import $ from 'jquery';
import { logoutUser } from '../../api/auth';

class CheckExpiredSession extends Component {

  render() {
    return (
      <ModalsBootstrap
        onClick={() => {
          this.props.logout();
          $('#modalCenter').modal('hide')
        }
        }
        okayButtonText={"Renew Session"}
        bodyText='Your session has expired'
        headerText='Session Timeout Warning'
      />
    );
  }
}

const checkExpiresSession = (authUser) => {
  const now = new Date();
  if ( !authUser.expireTime ) {
    if (authUser['no_expire']) {
      authUser[ 'expireTime' ] = now.getTime() + Infinity;
    } else if (! authUser['no_expire']) {
      authUser[ 'expireTime' ] = now.getTime() + 28800000;
    }
    store.set('user', authUser);
  } else {
    if ( now.getTime() >= authUser[ 'expireTime' ] ) {
      $('#modalCenter').modal({
        backdrop: 'static',
        keyboard: false
      });
    }
  }
};

export { checkExpiresSession };

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      logoutUser({})(dispatch);
    },
  };
};

export default connect(() => ({}), mapDispatchToProps)(CheckExpiredSession);



// WEBPACK FOOTER //
// ./src/containers/CheckExpiredSession/CheckExpiredSession.js